/* tslint:disable */
export enum WageCodeType {
    Work = 0,
    Travel = 1
}